import React from 'react'
import {Image} from "@chakra-ui/react"

const GroupIcon = (w,h) => {
  return (
      <>
    {/* <img width={`${w}px`} height={`auto`} */}
    <img width={`30px`} height={`auto`}
    src={"./assets/people-group-solid.svg"} 
    ></img>
    </>
  )
}

export default GroupIcon